<template>
    <div class="col-12">
        <div class="form-group row m-b-sm">
            <div class="col p-r-5">
                <button v-if="!disabled" class="btn btn-primary m-t-xs" type="button" @click="$emit('addNewItem')">
                    <i class="fa fa-plus"></i> {{ __('add_another_listing') }}
                </button>
            </div>

            <div class="col text-right max-w-160 p-l-5 p-r-5"></div>
            <div class="col text-right max-w-160 p-l-5 p-r-5"></div>
            <div class="col text-right max-w-160 p-l-5 p-r-5"></div>

            <div :class="{'has-error': hasError('net_amount') }" class="col text-right max-w-120 p-l-5 p-r-5">
                <RoundingInputWrapper
                    v-if="rounding && roundingInputs.includes('net_amount')"
                    ref="roundingNetAmount"
                    :errors="getErrors('net_amount')"
                    :label="__('sum')"
                    :threshold="threshold"
                    :rounding="roundings.net"
                    :value="sums.net | money"
                    classNames="form-control text-right"
                    disabled
                    @input="emitInput('net', $event)"
                />
                <InputWrapper
                    v-else
                    :errors="getErrors('net_amount')"
                    :label="__('sum')"
                    :value="sums.net | money"
                    classNames="form-control text-right"
                    disabled
                />
            </div>

            <div class="max-w-110 col  p-l-5 p-r-5"></div>

            <div class="max-w-120 col text-right  p-l-5 p-r-5">
                <InputWrapper
                    :label="__('sum')"
                    :value="sums.vat | money"
                    classNames="form-control text-right"
                    disabled
                />
            </div>

            <div :class="{'has-error': hasError('gross_amount') }" class="max-w-120 col text-right  p-l-5 p-r-5">
                <RoundingInputWrapper
                    v-if="rounding && roundingInputs.includes('gross_amount')"
                    ref="roundingGrossAmount"
                    :errors="getErrors('gross_amount')"
                    :label="__('sum')"
                    :threshold="threshold"
                    :rounding="roundings.gross"
                    :value="sums.gross | money"
                    classNames="form-control text-right"
                    disabled
                    @input="emitInput('gross', $event)"
                />
                <InputWrapper
                    v-else
                    :errors="getErrors('gross_amount')"
                    :label="__('sum')"
                    :value="sums.gross | money"
                    classNames="form-control text-right"
                    disabled
                />
            </div>

            <div style="width: 45px"></div>

        </div>
    </div>
</template>

<script>
import hasErrors from "../../../../mixins/hasErrors";
import InputWrapper from "../../../form/InputWrapper";
import RoundingInputWrapper from "../../../form/RoundingInputWrapper";
import inputEmit from "../../../../mixins/inputEmit";
import {mapGetters} from "vuex/dist/vuex.esm.browser";

export default {
    name: "SummaryRow",
    components: {RoundingInputWrapper, InputWrapper},
    mixins: [hasErrors, inputEmit],
    computed: {...mapGetters({threshold: 'getThreshold'})},
    props: {
        sums: {
            type: Object,
            required: true,
        },
        roundingInputs: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        rounding: {
            type: Boolean,
            default: false,
        },
        roundings: {
            type: Object,
            required: false,
        },
    },
    methods: {
        resetThreshold() {
            if (this.rounding) {
                this.$refs.roundingNetAmount.resetThreshold();
                this.$refs.roundingGrossAmount.resetThreshold();
            }
        },
    },
};
</script>
